export default [
  {
    path: "/ans-report",
    name: "ans-report",
    redirect: "/ans-report/home",
    meta: { title: "智税报告在线编辑器" },
    component: () => import("@/layouts/PageLayouts.vue"),
    children: [
      {
        path: "/ans-report/home",
        name: "ans-report-home",
        component: () => import("@/views/ans-report/home/index.vue"),
        meta: { title: "智税报告在线编辑器" },
      },
      {
        path: "/ans-report/class",
        name: "ans-report-class",
        component: () => import("@/views/ans-report/class/index.vue"),
        meta: { title: "智税报告在线编辑器" },
      },
      {
        path: "/ans-report/comments",
        name: "ans-report-comments",
        component: () => import("@/views/ans-report/comments/index.vue"),
        meta: { title: "报告详情" },
      },
    ],
  },
];